module.exports = __webpack_public_path__ + "img/fm-f-Path 48 Copy@3x.32917776.png";